define('widgets/notificationImage/viewmodel',[], function () {

    var NotificationImage = function() {};

    NotificationImage.prototype.activate = function(settings) {
        this.notification = settings.notification;
        this.size = settings.size;
    };

    return NotificationImage;
});

